import dayjs from 'dayjs';
import { EXPIRATION_DAYS_THRESHOLD } from '../common/constants';
// import { random } from '../common/Utilities';
import EntityMapper from '../models/EntityMapper';
import Perk from '../models/Perk';
import { SearchImpressionDescriptor } from '../models/Analytics';

export default class ADPerkMapper implements EntityMapper<any, Perk> {
  private language = window.l.locale;
    //   private language = currentLanguage();
  private localizedStringFields = ['title', 'tagline', 'description', 'articleBody', 'logo', 'image', 'keywords'];
  private localizedStringArrayFields = [];

  constructor(public impressionDescriptor?: SearchImpressionDescriptor) {}

  map = (data: any): Perk => {
    const perk = data;
    // this.mapLocalizedStringFields(perk);
    // this.mapLocalizedStringArrayFields(perk);

    perk.isExpiring = perk.dateOfferEnd
      ? dayjs(perk.validTo).subtract(EXPIRATION_DAYS_THRESHOLD, 'day').isBefore(new Date())
      : false;

    // TODO: (Rating) should come from API.
    // perk.rating = random(0, 5);
    perk.rating = 4;
    perk.category = perk.category.length > 0 ? perk.category[0] : perk.category;
    perk.subcategory = perk.subcategory.length > 0 ? perk.subcategory[0] : perk.subcategory;

    if (this.impressionDescriptor) {
      if (this.impressionDescriptor.templateId) perk.templateId = this.impressionDescriptor.templateId;
      if (this.impressionDescriptor.query) perk.searchQuery = this.impressionDescriptor.query;
    }

    return perk;
  };

  mapLocalizedStringFields(data: any) {
    for (const field of this.localizedStringFields) {
      data[field] = data[field][this.language];
    }
  }

  mapLocalizedStringArrayFields(data: any) {
    for (const field of this.localizedStringArrayFields) {
      data[field] = data[field][this.language];
    }
  }
}
